import type {
  NiceModalHandler,
  NiceModalHocProps,
} from "@ebay/nice-modal-react";
import { useModal as useNiceModal } from "@ebay/nice-modal-react";

type UseModalProps<P extends NiceModalHocProps> = {
  modal: React.FC<P>;
};

export const useModal = <P extends NiceModalHocProps>(
  props: UseModalProps<P>,
): Omit<NiceModalHandler, "show"> & {
  show: (args: Omit<P, "id">) => Promise<unknown>;
} => {
  const modal = useNiceModal(props.modal);

  return {
    ...modal,
    show: (args) => modal.show(args as P),
  };
};
